import { useEffect, useState } from 'react';
import { isSafari } from '@/utils/browser-kit';
import { loadImageAsync } from '@/utils/file-kit';

const Mask: React.FC<{
    maskURL: string;
    stageWidth: number;
    stageHeight: number;
    isOperating: boolean;
    scale: number;
}> = ({ maskURL, stageWidth, stageHeight, isOperating, scale }) => {
    const [reverseMaskURL, setReverseMaskURL] = useState<string>('');
    useEffect(() => {
        if (isOperating) {
            return;
        }
        if (!maskURL) {
            setReverseMaskURL('');
            return;
        }
        const getReverseMaskURL = async () => {
            const img = await loadImageAsync(maskURL, false);

            const canvas = document.createElement('canvas');
            canvas.width = stageWidth * scale;
            canvas.height = stageHeight * scale;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                return;
            }
            ctx.fillStyle = 'rgba(0,0,0)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.globalCompositeOperation = 'destination-out';
            if (isSafari) {
                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, stageWidth * scale, stageHeight * scale);
            } else {
                ctx.drawImage(img, 0, 0);
            }
            const reverseMaskURL = canvas.toDataURL('image/png');
            setReverseMaskURL(reverseMaskURL);
        };
        getReverseMaskURL();
    }, [maskURL, stageWidth, stageHeight, isOperating, scale]);
    if (!reverseMaskURL || isOperating) {
        return null;
    }
    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                WebkitMaskImage: `url(${reverseMaskURL})`,
                WebkitMaskSize: `${stageWidth * scale}px ${stageHeight * scale}px`,
                backgroundColor: 'rgba(255,255,255,0.9)',
            }}
        ></div>
    );
};

export default Mask;
